import React from 'react';
import MarkdownHtml from '@base/product/MarkdownHtml';
import TabPartTitle from '@app/product/TabPartTitle';
import styles from './index.module.less'
import { LazyLoad } from '@base/lib/LazyLoad';
import { useTrans } from 'base/utils/i18n';
import cn from 'classnames';

declare type IProps = {
    content: string;
}

const ProductMarkdownHtml: React.FC<IProps> = ({ content }) => {
    const { t } = useTrans();
    return (
        <div className={cn(styles['markdown-html-wrap'], 'wrapper')}>
            <TabPartTitle title={t('web_product_tab_description')}/>
            <LazyLoad>
                <MarkdownHtml content={content}/>
            </LazyLoad>
        </div>
    )
}
export default React.memo(ProductMarkdownHtml);
